import React from 'react';
import { Input } from 'antd';
import { I18n } from '@aws-amplify/core';
import { FormItemWrapper } from '@/components/Settings/DataExtraction/styles';
import { CustomInputContainer } from './styles';

export function NameFormItem(): JSX.Element {
	return (
		<FormItemWrapper name="name" label={I18n.get('Name')} labelCol={{ span: 24 }}>
			<CustomInputContainer>
				<Input placeholder={I18n.get('Name')} />
			</CustomInputContainer>
		</FormItemWrapper>
	);
}
